// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9562 ? "3975359d" : chunkId) + "." + {"981":"aca73b9d79cebae2","9562":"112a1690336157a3"}[chunkId] + ".js";
};